<template>
  <div class="login-page">
    <div class="login-shell">
      <div class="login-panel">
        <div class="login-brand">
          <div class="login-brand-mark">CP</div>
          <div>
            <h1>AvanceDigital</h1>
            <p>Gestão administrativa</p>
          </div>
        </div>

        <form class="login-form" @submit.prevent="validaUser()">
          <div class="login-title">
            <h2>Acessar sistema</h2>
            <span>Informe seus dados para continuar.</span>
          </div>

          <label class="login-field">
            <span>Login</span>
            <div class="login-input-wrap">
              <input v-model="login" type="text" class="form-control" placeholder="Digite seu login"
                autocomplete="username">
              <i class="icon-copy dw dw-user1"></i>
            </div>
          </label>

          <label class="login-field">
            <span>Senha</span>
            <div class="login-input-wrap">
              <input v-model="senha" :type="senhaVisivel ? 'text' : 'password'" class="form-control"
                placeholder="Digite sua senha" autocomplete="current-password">
              <button type="button" class="login-password-toggle" @click="toggleSenhaVisivel"
                :aria-label="senhaVisivel ? 'Ocultar senha' : 'Mostrar senha'">
                <i :class="senhaVisivel ? 'mdi mdi-eye-off-outline' : 'dw dw-padlock1'"></i>
              </button>
            </div>
          </label>

          <div class="login-actions-row">
            <button type="button" class="login-link" @click="dialog = true">Esqueci minha senha</button>
          </div>

          <button class="btn btn-primary btn-lg btn-block login-submit" type="submit">
            Acessar
          </button>
        </form>
      </div>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent width="600">
        <v-card>
          <v-card-title>
            <span class="text-h5" style="padding-left: 10px;">Lembrar Senha</span>
          </v-card-title>
          <v-card-text>
            <input v-model="resetEmail" type="text" class="form-control form-control-lg" placeholder="Digite seu E-mail">
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog = false"
              style="padding-right: 20px;">Fechar</v-btn>
            <a class="btn btn-primary btn-lg btn-block" style="width: 100px;padding-right: 10px;" href="#" @click.prevent="EnviaReset();dialog=false">Enviar</a>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>



  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { SHA256 } from 'crypto-js';


export default {
  name: 'LoginView',
  components: {
    moment,
  },
  data: () => ({
    dialog: false,
    login: '',
    senha: '',
    senhaVisivel: false,
    User: {},
    resetEmail:'',
    UserReset:[],
    templateEmail:[],
    TelasUser:[],
  }),
  methods: {
    toggleSenhaVisivel() {
      this.senhaVisivel = !this.senhaVisivel;
    },
    validaUser() {
      if (this.login == '' || this.login == null) {
        this.$mensagemErro("Login obrigatório.")
      }
      else if (this.senha == '' || this.senha == null) {
        this.$mensagemErro("Senha obrigatória.")
      }
      else {
        axios.post('/Auth/Login', {
          login: this.login,
          senha: this.senha
        })
          .then(response => {
              this.User = response.data;
              let _dadoUser = {
                cusId: this.User.cusId || this.User.CusId,
                nome: this.User.nome || this.User.Nome,
                urlimage: this.User.urlImage || this.User.UrlImage,
                menu: this.User.menu || this.User.Menu || []
              }
              sessionStorage.setItem('_userav', JSON.stringify(_dadoUser));
              this.$router.push('/Home')
          });
      }
    },
    EnviaReset() {
      if (this.resetEmail == '' || this.resetEmail == null) {
        this.$mensagemErro("Digite e-mail cadastrado.")
      }
      else {

        axios.get(`/Process/CadMensagensPadrao/GetAll`)
                .then(response => {
                    this.templateEmail = response.data.filter(x=> x.mpdId == 1);

                    const param1 = this.resetEmail;
                    axios.get(`/Process/UsrCadastroUsuarios/GetByEmail/${param1}`).then(response => {
                      this.UserReset = response.data;  
                      if (this.UserReset!='') {
                          const encrypted = SHA256(this.UserReset.cusEmail).toString();
                          let _dadosEmail = {
                                                nomeDe: this.$nomeRemetenteSistema,
                                                nomePara: this.UserReset.cusNome,
                                                assunto: 'Reset de Senha',
                                                destinatario: this.UserReset.cusEmail,
                                                emailResposta: this.$emailRespostaPadrao,
                                                textoEmail: this.templateEmail[0].mpdTexto.replace('[SenhaReset]', this.$resetSenhaBaseURL + '/' + this.UserReset.cusId + '/' + encrypted),
                                                nomeAnexo: '',
                                                anexo: '',
                                                tipoAnexo: ''
                                              }
                                    axios.post(`/Process/AdmControleSmtp/Enviamail`,_dadosEmail)
                                    .then(response => {
                                        if (response.data == 1){
                                          this.$mensagemSucesso("Link para reset de senha enviado para o seu e-mail! ");
                                          this.resetEmail = "";
                                        }
                                      });
                    }
                    else{
                      this.$mensagemErro("E-mail não cadastrado")
                    }
              });
        });
      }
    }
  },
  created() {
   
  }
}
</script>

<style>
.login-page {
  align-items: center;
  background: #f3f5f7;
  color: #172331;
  display: flex;
  min-height: 100vh;
  padding: 32px 16px;
}

.login-shell {
  display: flex;
  justify-content: center;
  width: 100%;
}

.login-panel {
  background: #ffffff;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, .08);
  max-width: 430px;
  padding: 34px;
  width: 100%;
}

.login-brand {
  align-items: center;
  display: flex;
  gap: 14px;
  margin-bottom: 34px;
}

.login-brand-mark {
  align-items: center;
  background: #2f6f73;
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  font-size: 17px;
  font-weight: 800;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.login-brand h1 {
  color: #172331;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.login-brand p,
.login-title span {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

.login-title {
  margin-bottom: 24px;
}

.login-title h2 {
  color: #172331;
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 6px;
}

.login-form {
  width: 100%;
}

.login-field {
  color: #334155;
  display: block;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}

.login-field > span {
  display: block;
  margin-bottom: 7px;
}

.login-input-wrap {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  display: flex;
  min-height: 46px;
  overflow: hidden;
  transition: border-color .18s ease, box-shadow .18s ease;
}

.login-input-wrap:focus-within {
  border-color: #2f6f73;
  box-shadow: 0 0 0 3px rgba(47, 111, 115, .12);
}

.login-input-wrap .form-control {
  border: 0;
  box-shadow: none;
  color: #172331;
  font-size: 14px;
  height: 46px;
  padding: 0 14px;
}

.login-input-wrap .form-control:focus {
  box-shadow: none;
}

.login-input-wrap > i,
.login-password-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #64748b;
  display: flex;
  flex: 0 0 46px;
  font-size: 20px;
  height: 46px;
  justify-content: center;
  padding: 0;
}

.login-password-toggle {
  cursor: pointer;
}

.login-password-toggle:hover {
  color: #2f6f73;
}

.login-actions-row {
  display: flex;
  justify-content: flex-end;
  margin: -4px 0 22px;
}

.login-link {
  background: transparent;
  border: 0;
  color: #2f6f73;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  padding: 0;
}

.login-link:hover {
  color: #24585c;
  text-decoration: underline;
}

.login-submit {
  background: #2f6f73 !important;
  border-color: #2f6f73 !important;
  border-radius: 8px;
  font-weight: 800;
  height: 46px;
}

@media (max-width: 575px) {
  .login-panel {
    padding: 26px 20px;
  }
}

.v-card-actions {
  align-items: center;
  display: flex;
  flex: none;
  min-height: 52px;
  padding: 0.5rem;
  padding-right: 20px !important;
}
</style>

